const state = {
  account: null,
  authorization: null,
  roleName: '',
  roleCode: '',
  getSearchKey: '',
  signOutReasonList: []
}

const getters = {
  getAccount: (state) => state.account,
  getAuthorization: (state) => state.authorization,
  getRoleName: state => state.roleName,
  getRoleCode: state => state.roleCode,
  getSearchKey: state => state.getSearchKey,
  getSignOutReasonList: state => state.signOutReasonList
}

const actions = {
  loadAccountData ({ commit }) {
    const accountData = localStorage.getItem('accountData')
    if (accountData) {
      commit('setAccount', JSON.parse(accountData))
    }
  }
}
const mutations = {
  setAccount (state, account) {
    state.account = account
    localStorage.setItem('accountData', JSON.stringify(account))
  },
  setAuthorization (state, authorization) {
    state.authorization = authorization
  },
  setRoleName (state, data) {
    state.roleName = data
  },
  setRoleCode (state, data) {
    state.roleCode = data
  },
  setSearchKey (state, data) {
    state.getSearchKey = data
  },
  setSignOutReasonList (state, data) {
    state.signOutReasonList = data
  }
}

export default {
  namespace: true,
  state,
  getters,
  actions,
  mutations
}
